import { Injectable } from '@angular/core';
import { CentralMessage } from '../models';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class MessageService {

  constructor(private _toastrServ: ToastrService, private _translateSer: TranslateService) {}

  displayMessage(message: CentralMessage) {
    const msgBody = this.formatMsg(message.body);
    switch (message.type) {
      case 'error': {
        this._toastrServ.error(msgBody);
        break;
      }
      case 'message': {
        this._toastrServ.info(msgBody);
        break;
      }
      case 'success': {
        this._toastrServ.success(msgBody);
        break;
      }
      default: {
        break;
      }
    }

  }

  formatMsg(message: string): string {
    return this._translateSer.instant(message);
  }
}
